
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getSerAuthMeList, batchQrCode } from '../../api/device';
import { getServiceList } from '../../api/service';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import dialogDeviceDetail from './components/DeviceDetail.vue';
import dialogDeviceRecord from './components/DeviceRecord.vue';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'DeviceTome',
  components: {
    dialogImgLarge,
    dialogDeviceDetail,
    dialogDeviceRecord
  }
})
export default class extends Vue {
  private formSearch:any = {
    authorized: ''
  };
  private authorizedOptions = [];
  private tableData = [];
  private selectedbox = [];
  private checkAll = false;
  private isIndeterminate: any = null;
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private dialogDeviceRecordVisible = false;
  private dialogDeviceDetailVisible = false;
  private rowData = {};

  private isShowDeviceHistry=false
  created() {
    this.isShowDeviceHistry = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.DeviceHistry);
    this.getSerAuthMeList();
    this.getServerList();
  }
  private improtQr() {
    if (!this.selectedbox || this.selectedbox.length < 1) {
      this.$notify.warning({
        title: '提示',
        message: '请选择设备'
      });
      return;
    }
    let id = '';
    for (var item of this.selectedbox) {
      id = id + (item as any).id + ',';
    }
    let params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.id = id.substring(0, id.length - 1);
    batchQrCode(params).then(res => {
    }).catch(err => {
      if (!err.msg) {
        let blob = new Blob([err]);
        let fileName = new Date().getTime() + '.pdf';
        if ('download' in document.createElement('a')) {
          // 非IE下载
          let elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          // navigator.msSaveBlob(blob, fileName);
        }
        this.$message.success('下载文件成功');
      } else {
        this.$message.error(err.msg);
      }
    });
  }

  handleSelectionChange(value: any) {
    let checkedCount = value.length;
    this.checkAll = checkedCount === this.tableData.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.tableData.length;
  }

  // 全选
  handleCheckAllChange(val: boolean) {
    this.selectedbox = val ? this.tableData : [];
    this.isIndeterminate = false;
  }

  handlePageSizeChange(val:number) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = val;
    this.getSerAuthMeList();
  }
  handleCurrentChange(val:number) {
    this.pagination.currentPage = val;
    this.getSerAuthMeList();
  }
  private getServerList() {
    let params: any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    getServiceList(params).then(res => {
      if (res.data) {
        this.authorizedOptions = res.data.list;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private getSerAuthMeList() {
    this.selectedbox = [];
    this.isIndeterminate = false;
    let params: any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    if (this.formSearch.authorized && this.formSearch.authorized.id) {
      params.servicer_company_id = this.formSearch.authorized.id;
    }
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    getSerAuthMeList(params)
      .then(res => {
        if (res.data && res.data.list.length > 0) {
          this.tableData = res.data.list;
          this.pagination.total = res.data.count;
        } else {
          this.tableData = [];
          this.pagination.total = 0;
        }
      })
      .catch(err => {
        this.tableData = [];
        this.pagination.total = 0;
        let msg = err.msg;
      });
  }
  private searchByAuth() {
    this.pagination.currentPage = 1
    this.getSerAuthMeList();
  }
  private restSearchByAuth() {
    this.pagination.currentPage = 1
    this.formSearch = {
      authorized: ''
    };
    this.getSerAuthMeList();
  }
  detailsHandle(val: any) {
    this.dialogDeviceDetailVisible = true;
    this.rowData = val;
  }
  closeDetailHandle(value: boolean) {
    this.dialogDeviceDetailVisible = value;
  }

  recordHandle(val:any) {
    this.dialogDeviceRecordVisible = true;
    this.rowData = val;
  }
  closeRecordHandle(value: boolean) {
    this.dialogDeviceRecordVisible = value;
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
}
